// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2Vnh6","errorLogs":"styles_errorLogs__2hRlL"};